import { Alert, Box, Button, CircularProgress, Paper, TextField, Typography } from '@mui/material';
import type React from 'react';
import { useState } from 'react';
import { useLogin } from 'react-admin';
import { clearSession } from '../providers/session';

export const LoginPage = () => {
  const login = useLogin();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login({ email, password });
      window.location.reload();
    } catch (err: any) {
      setError(err?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    clearSession();
    setEmail('');
    setPassword('');
    setError('');
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
      }}
    >
      <Paper
        elevation={4}
        sx={{
          p: 4,
          width: '100%',
          maxWidth: 400,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Typography variant="h5" fontWeight={700} align="center">
          Q4uDoc Admin
        </Typography>
        <Typography variant="body2" color="text.secondary" align="center">
          Sign in with your admin email and password.
        </Typography>

        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}
        >
          <TextField
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            fullWidth
            autoComplete="email"
            size="small"
          />
          <TextField
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            fullWidth
            autoComplete="current-password"
            size="small"
          />
          <Button type="submit" variant="contained" fullWidth disabled={loading} sx={{ mt: 1 }}>
            {loading ? <CircularProgress size={22} color="inherit" /> : 'Sign in'}
          </Button>
        </Box>

        {error && <Alert severity="error">{error}</Alert>}

        <Button
          variant="text"
          size="small"
          color="inherit"
          onClick={handleLogout}
          sx={{ color: 'text.disabled', mt: 1 }}
        >
          Clear stored token
        </Button>
      </Paper>
    </Box>
  );
};
